import { render, staticRenderFns } from "./BaseInputArray.vue?vue&type=template&id=1f791eed&"
import script from "./BaseInputArray.vue?vue&type=script&lang=js&"
export * from "./BaseInputArray.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputArray.vue?vue&type=style&index=0&id=1f791eed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports